import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const IconProvider1spin4win = ({ className }) => (
  <svg
    className={classNames('producers-svg-icon', className)}
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M29.9986 29.9419L4 44.9129V14.971L29.9986 0V29.9419Z" fill="#E2A354" />
    <path d="M29.9985 29.9419L55.9999 44.9129V14.971L29.9985 0V29.9419Z" fill="#041C1C" />
    <path d="M4 44.9128L29.9986 60L56 44.9128L29.9986 29.9419L4 44.9128Z" fill="#041C1C" />
    <path
      d="M15.6099 32.4762L20.3529 29.8581V11.4315L16.2809 13.9334L10.1499 21.1285L11.6272 23.7195L15.6559 19.2507L15.6099 32.4762Z"
      fill="#041C1C"
    />
    <path
      d="M43.8328 14.2226L39.1601 11.6423L35.4534 21.2096V24.649L43.3647 28.7937V31.9738L47.5152 34.2163V31.3469L48.9654 32.1872L48.9194 28.6397L47.5152 27.8696V23.4521L43.3647 21.2366V25.4326L39.317 23.2954L43.8328 14.2226Z"
      fill="#E2A354"
    />
    <path
      d="M27.1603 52.6455L24.7469 47.8038L16.3999 46.5096L23.4265 43.8699L23.3994 38.7445L29.7523 41.6949L38.1263 40.2197L35.3774 44.775L40.5371 48.736H31.9033L27.1603 52.6455Z"
      fill="#E2A354"
    />
  </svg>
);

IconProvider1spin4win.propTypes = {
  className: PropTypes.string
};

IconProvider1spin4win.defaultProps = {
  className: ''
};
